import PropTypes from 'prop-types';
import LinkButton from 'components/controls/links/link-button';
import ExternalIcon from 'assets/icons/link-external.svg';
import styles from './external-link.module.scss';
const ExternalLinkButton = ({ href, text }) => {
	return (
		<LinkButton
			href={href}
			text={text}
			rightIcon={<ExternalIcon className={styles.icon} />}
		/>
	);
};

ExternalLinkButton.propTypes = {
	href: PropTypes.string.isRequired,
	text: PropTypes.string,
};

export default ExternalLinkButton;
